import { SVGIcon } from '@superops/super-icons';
import React from 'react';
import Select from 'react-select';
import { getTranslatedText, getLokaliseKeyByProduct } from '@nile/components';
import {
  DropdownIndicator,
  formatGroupLabel,
  IndicatorSeparator
} from '@nile/mangifera/src/Pebbles/select';
import { reactSelectErrorStyles } from '@nile/banyan/src/Utils/style';

const TechnicianSection = (props) => {
  const {
    technicians,
    data,
    setSharedTech,
    intl,
    errors,
    currentProduct
  } = props;

  return (
    <div className="flex visibilityContainer g10">
      <div className={`flex g10 ${data?.users?.length ? 'w70' : 'w350'}`}>
        <div className="flex actr">
          <SVGIcon name="Employee" />
        </div>
        <div className="full-width">
          <Select
            classNamePrefix="value_selector"
            formatGroupLabel={formatGroupLabel}
            value={data?.users}
            components={{ IndicatorSeparator, DropdownIndicator }}
            onChange={(val) => {
              setSharedTech({ users: val });
            }}
            options={technicians}
            placeholder={getTranslatedText(
              intl,
              getLokaliseKeyByProduct(
                currentProduct,
                'chooseTechnicianPlaceholder'
              )
            )}
            menuPortalTarget={document.body}
            menuPlacement="auto"
            closeMenuOnScroll={(e) => {
              return (
                e.target &&
                e.target.classList &&
                !(e.target.classList.value.indexOf('menu-list') > -1)
              );
            }}
            name="valueselector"
            isMulti
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              menu: (base) => ({ ...base, zIndex: 9999 }),
              ...(errors &&
                errors?.[0]?.error?.users?.[0] &&
                reactSelectErrorStyles)
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default TechnicianSection;
